import writeContainerStylesToCss from './css/writeContainerStylesToCss';
import useLiveUpdateCss from './useLiveUpdateCss';
import updateBackgroundDom from './updateBackgroundDom';
export default function ContainerStyleRenderer({
  container,
  breakpointMediaQueries
}) {
  const parentNode = container.getParentNode();
  const {
    styles,
    layout
  } = container.getValue();
  const css = writeContainerStylesToCss({
    containerId: container.getId(),
    layout: layout.layout,
    breakpointStyles: styles.breakpointStyles,
    breakpointConfigs: breakpointMediaQueries,
    parentNode
  });
  useLiveUpdateCss(css);
  updateBackgroundDom(container, breakpointMediaQueries);
  return null;
}